
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vaults",
      function () {
        return require("private-next-pages/vaults/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vaults"])
      });
    }
  